import type { ApolloError } from "@apollo/client";
import type { MostRecentIssueWithClosedEventWithoutFeedbackQuery } from "@medbillai/generated-graphql-types";
import { IssueSummary } from "./IssueSummary";
import { WidgetWrapper } from "./WidgetWrapper";
type ClosedEvent = NonNullable<MostRecentIssueWithClosedEventWithoutFeedbackQuery["issue__ClosedEvent"]>[number];
type ResolvedCaseProps = {
  closedEvent: ClosedEvent | null;
  error: ApolloError | undefined;
};
export function ResolvedCase({
  closedEvent,
  error
}: ResolvedCaseProps) {
  // Don't show widget if there's an error or no data
  if (error || !closedEvent) {
    return null;
  }
  const {
    issue
  } = closedEvent;
  return <WidgetWrapper title="Closed cases" titleProps={{
    pb: "$0"
  }} data-sentry-element="WidgetWrapper" data-sentry-component="ResolvedCase" data-sentry-source-file="ResolvedCase.tsx">
      <IssueSummary issue={issue} stackProps={{
      marginHorizontal: "$-4",
      paddingHorizontal: "$4"
    }} data-sentry-element="IssueSummary" data-sentry-source-file="ResolvedCase.tsx" />
    </WidgetWrapper>;
}